import { IBottomLink } from '../../../../../data/tools/types';

import useStyles from './styles';

type BottomLinksProps = {
  links: IBottomLink[];
};

export function BottomLinks({ links }: BottomLinksProps) {
  const classes = useStyles();

  return (
    <ul className={classes.root}>
      {links.map(({ text, href }) => (
        <li key={href}>
          <a href={href} className={classes.text}>
            {text}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default BottomLinks;
